// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".UiSkeleton[data-v-4da39e99]{animation:pulse-data-v-4da39e99 1.5s infinite}@keyframes pulse-data-v-4da39e99{50%{opacity:.5}}\n", ""]);
// Exports
module.exports = exports;
